import { defineStore } from 'pinia';
import { reactive, ref } from 'vue';

export default defineStore('review', () => {
  const templateData = reactive({});
  const index = ref(0);

  const setTemplateData = (data) => {
    const temp = structuredClone(data);

    Object.keys(templateData).forEach((key) => {
      delete templateData[key];
    });

    Object.entries(temp).forEach(([key, value]) => {
      templateData[key] = value;
    });
  };

  const setIndex = (i) => {
    index.value = i;
  };

  return {
    templateData,
    setTemplateData,
    index,
    setIndex,
  };
});
